import { NextPage } from 'next'
import { useState } from 'react'
import { FaHistory } from 'react-icons/fa'
import InfiniteScroll from 'react-infinite-scroller'
import { ArticleList } from 'web_core/assets/article/List'
import { LoadingSpinner } from 'web_core/assets/spinners'
import { useAuthState } from 'web_core/firebase/hooks'
import { useESArticles } from 'web_core/hooks/models/useESArticles'
import { DefaultLayout } from '~/components/Layout/Default'
import { ContentNavSelector } from '~/components/Utils/ContentNavSelector'
import { FollowingNavSelector } from '~/components/Utils/FollowingNavSelector'
import { Heading } from '~/components/Utils/Heading'
import { LoginRecommender } from '~/components/Utils/LoginRecommender'
import { SearchFilter } from '~/components/Utils/SearchFilter'
import { useLayoutProperty } from '~/context/layout_property'
import {
  LayoutStaticProps,
  getDefaultLayoutStaticProps,
} from '~/static_props/layout'
import { articleTimelineBreadcrumb } from '~/utils'

export const getStaticProps = getDefaultLayoutStaticProps

const Page: NextPage<LayoutStaticProps> = ({ categories, popularProfiles }) => {
  const [categoryId, setCategoryId] = useState<string>()
  const { articles, loadMore, isReachingEnd, isLoadingMore } = useESArticles({
    locale: 'ja',
    type: 'timeline',
    mode: 'followee',
    category_id: categoryId,
  })

  const { headerHeight } = useLayoutProperty()

  const { isSignedIn } = useAuthState()

  return (
    <DefaultLayout
      head={{ title: '記事のタイムライン', index: false }}
      leftSidebar
      rightSideBar
      categoriesMenu={{ pc: true, sp: true }}
      staticCategories={categories}
      staticPopularProfiles={popularProfiles}
      navLinks={{ pc: true, tablet: true, sp: true, active: 'timeline' }}
    >
      {articleTimelineBreadcrumb.toReactNode()}
      <Heading title="タイムライン" icon={FaHistory} className="mb-0" />
      <div
        className="sticky-top bg-white pt-2 pb-2 mb-2"
        style={{ top: headerHeight }}
      >
        <ContentNavSelector
          active="articles"
          link="/timeline/following_[contents]"
          className="mb-2 mb-md-4"
        />
        <div className="d-flex justify-content-between gap-4">
          <FollowingNavSelector
            active="following"
            link="/timeline/[prefix]articles"
            className="flex-shrink-0 fs-7 fs-md-6"
          />
          <SearchFilter
            categoryFilter={{ onSelectId: setCategoryId, id: categoryId }}
            className="fs-7 fs-md-6"
          />
        </div>
      </div>
      <LoginRecommender
        suffix="することでフォロー中のユーザーやタグの記事のみを表示できます。"
        className="mb-4 py-2"
      />
      {isSignedIn === true && (
        <InfiniteScroll
          loadMore={async () => {
            if (isLoadingMore === false && isReachingEnd === false)
              await loadMore()
          }}
          hasMore={isReachingEnd === false}
          loader={<LoadingSpinner />}
        >
          {articles && (
            <ArticleList
              articles={articles}
              className="grid g-cols-1 g-lg-cols-2"
            />
          )}
        </InfiniteScroll>
      )}
    </DefaultLayout>
  )
}

export default Page
